<header-desktop *limitUp="DEVICE_SIZE.DESKTOP" [components]="components" />

<header-mobile *smallerThan="DEVICE_SIZE.DESKTOP" [components]="components" />
